import {
  Sun,
  CloudSun,
  Cloud,
  CloudFog,
  CloudDrizzle,
  CloudRain,
  CloudSnow,
  CloudLightning,
} from 'lucide-react';

/**
 * MET's `symbol_code` has ~140 variants (day/night/polar-twilight suffixes on
 * top of the weather family). The sheet doesn't need that resolution — map
 * down to about ten families, rendered as inline SVGs (lucide, not an icon
 * font — spec 11), tokens-colored via `currentColor`.
 */
type SymbolFamily =
  | 'clear'
  | 'fair'
  | 'partlycloudy'
  | 'cloudy'
  | 'fog'
  | 'lightrain'
  | 'rain'
  | 'sleet'
  | 'snow'
  | 'thunder';

export function classifySymbol(symbolCode: string | null): SymbolFamily {
  const s = (symbolCode ?? '').toLowerCase();
  if (s.includes('thunder')) return 'thunder';
  if (s.includes('sleet')) return 'sleet';
  if (s.includes('snow')) return 'snow';
  if (s.includes('lightrain') || s.includes('drizzle')) return 'lightrain';
  if (s.includes('rain')) return 'rain';
  if (s.includes('fog')) return 'fog';
  if (s.startsWith('partlycloudy')) return 'partlycloudy';
  if (s.startsWith('cloudy')) return 'cloudy';
  if (s.startsWith('fair')) return 'fair';
  if (s.startsWith('clearsky')) return 'clear';
  return 'cloudy';
}

const ICONS: Record<SymbolFamily, typeof Sun> = {
  clear: Sun,
  fair: CloudSun,
  partlycloudy: CloudSun,
  cloudy: Cloud,
  fog: CloudFog,
  lightrain: CloudDrizzle,
  rain: CloudRain,
  sleet: CloudRain,
  snow: CloudSnow,
  thunder: CloudLightning,
};

export function WeatherSymbolIcon({ symbolCode, size = 18 }: { symbolCode: string | null; size?: number }): JSX.Element {
  const Icon = ICONS[classifySymbol(symbolCode)];
  return <Icon size={size} aria-hidden="true" />;
}
